/**
 * Where the recruitment app is deployed.
 *
 * The recruitment page is a separate Vite build on its own subdomain, so this
 * is a full navigation and not a router route. Override with
 * REACT_APP_RECRUITMENT_URL at build time if the subdomain changes.
 */
export const RECRUITMENT_URL =
	process.env.REACT_APP_RECRUITMENT_URL || "https://apply.iecse-manipal.com";
